import LoadingCenter from "../LoadingCenter";
import "./ListParts.css";

/**
 * Cartão de resumo das listagens (Vales, Consumo da equipe, Pagamentos da equipe): rótulo,
 * valor e ícone, com a cor de destaque na faixa lateral, no valor e no ícone.
 *
 * Sem ação: os filtros continuam concentrados no acordeão acima. Antes cada tela tinha a
 * própria cópia deste cartão e do CSS dele, idênticas.
 *
 * @param {string} accent - primary, success, warning, info ou danger.
 * @param {boolean} loading - Mostra o carregamento no lugar do valor.
 * @param {string} caption - Linha opcional abaixo do valor, para um complemento curto
 *                           (ex.: "Último em 04/10/2026 06:59").
 */
const ListMetricCard = ({ accent = 'primary', label, value, icon, loading, caption }) => (
    <div className={`list-metric-card list-metric-card--${accent}`}>
        {loading ? (
            <LoadingCenter />
        ) : (
            <div className="list-metric-card__head">
                <div>
                    <span className="list-metric-card__label">{label}</span>
                    <strong className="list-metric-card__value">{value}</strong>
                    {caption && <span className="list-metric-card__caption">{caption}</span>}
                </div>
                <span className="list-metric-card__icon">
                    <i className={icon}></i>
                </span>
            </div>
        )}
    </div>
);

/**
 * Grade dos cartões: três por linha (ou quatro, com columns={4}), duas em tela média e uma
 * no celular. Quatro existe para a tela com quatro cartões não sobrar um sozinho na linha.
 */
export const ListMetricCards = ({ children, columns = 3 }) => (
    <div className={`list-metric-cards list-metric-cards--${columns} mb-4`}>{children}</div>
);

export default ListMetricCard;
